import React from 'react';

export interface PageHeaderProps {
  /** Titre de la page — Varela Round, un seul par écran. */
  title: React.ReactNode;
  /** Une phrase qui dit à quoi sert l'écran. */
  subtitle?: React.ReactNode;
  /** Actions principales (boutons, filtres) alignées à droite. */
  actions?: React.ReactNode;
  /** Petite étiquette au-dessus du titre (ex. "Aujourd'hui"). */
  eyebrow?: React.ReactNode;
  className?: string;
}

/**
 * En-tête de page unique pour tout le dashboard restaurateur :
 * même police, même espacement, actions toujours au même endroit.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, eyebrow, className = '' }) => (
  <div className={`flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`}>
    <div className="min-w-0">
      {eyebrow && <p className="eyebrow mb-1.5">{eyebrow}</p>}
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="page-subtitle max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2 sm:justify-end flex-shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
